module.exports = __webpack_public_path__ + "img/backgroundImg.7c1ac9fa.png";